import { render, staticRenderFns } from "./refer-bonus-list.vue?vue&type=template&id=5e67a910&scoped=true&"
import script from "./refer-bonus-list.vue?vue&type=script&lang=js&"
export * from "./refer-bonus-list.vue?vue&type=script&lang=js&"
import style0 from "./refer-bonus-list.vue?vue&type=style&index=0&id=5e67a910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67a910",
  null
  
)

export default component.exports